/**
 * @generated SignedSource<<d42304a070e7b80d2e158404e02e4bb3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type rows_jiraProject$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_project">;
  readonly " $fragmentType": "rows_jiraProject";
};
export type rows_jiraProject$key = {
  readonly " $data"?: rows_jiraProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"rows_jiraProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "rows_jiraProject",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "row_nativeIssueTable_project"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "0c27ea89891ec179f72de204e51be5b1";

export default node;
